/**
 * @desc 调整单一键出库
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(adNo: string | number, options?: any) {
  return updateResponse(
    http(URL + `/stockAdjustmentMaster/oneClickOutbound/${adNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
